import { render, staticRenderFns } from "./table.dictionary.vue?vue&type=template&id=715e64d8&"
import script from "./table.dictionary.vue?vue&type=script&lang=js&"
export * from "./table.dictionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports